import * as React from 'react';

class OkaySvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 26 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon okay-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path d="M10.7771 21.3382L25.5503 8.52212L10.2383 26.9169L0.0004262 18.3948L10.7771 21.3382Z" fill="white" />
      </svg>
    );
  }
}

export default OkaySvg;
